export default "__VITE_ASSET__CKCD9gqI__"